"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

class Menu extends _react.PureComponent {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "toggle", () => {
      this.setState(({
        isOpen
      }) => ({
        isOpen: !isOpen
      }), () => {
        this.props.onToggle(this.state.isOpen);
      });
    });
    (0, _defineProperty2.default)(this, "close", () => {
      this.setState({
        isOpen: false
      }, this.props.onToggle(false));
    });
    (0, _defineProperty2.default)(this, "handleClickOutside", e => {
      if (!this.menuRef.current.contains(e.target) && this.state.isOpen) {
        this.close();
      }
    });
    this.state = {
      isOpen: false
    };
    this.menuRef = /*#__PURE__*/_react.default.createRef();
  }

  componentDidMount() {
    if (!this.props.noOffClickClose) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (!this.props.noOffClickClose) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  render() {
    const {
      isOpen
    } = this.state;
    return this.props.children({
      isOpen,
      toggle: this.toggle,
      menuRef: this.menuRef,
      close: this.close,
      ...this.props
    });
  }

}

Menu.propTypes = {
  onToggle: _propTypes.default.func
};
Menu.defaultProps = {
  onToggle: () => {}
};
var _default = Menu;
exports.default = _default;
module.exports = exports.default;